import { render, staticRenderFns } from "./NeverUseCourier.vue?vue&type=template&id=c1a6a9b6&scoped=true&"
import script from "./NeverUseCourier.vue?vue&type=script&lang=js&"
export * from "./NeverUseCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a6a9b6",
  null
  
)

export default component.exports